import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Play } from 'lucide-react';

interface DemoModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  videoUrl: string;
  title: string;
}

const DemoModal = ({
  open,
  onOpenChange,
  videoUrl,
  title
}: DemoModalProps) => {
  // Extract YouTube video ID from URL
  const getYouTubeVideoId = (url: string) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  };

  const videoId = getYouTubeVideoId(videoUrl);
  const embedUrl = videoId ? `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1` : '';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-5xl w-[95vw] h-[90vh] bg-black/90 border border-white/20 p-0 overflow-hidden">
        <div className="relative w-full h-full flex flex-col">
          {/* Simplified header with just title */}
          <DialogHeader className="flex items-center justify-between p-4 border-b border-white/10">
            <DialogTitle className="text-lg font-semibold text-white">{title}</DialogTitle>
            <DialogDescription className="text-sm text-gray-300 mt-1">
              Watch our product demonstration video to see how the platform works
            </DialogDescription>
          </DialogHeader>
          
          {/* Video container - takes full remaining space */}
          <div className="flex-1 p-4">
            {embedUrl ? (
              <div className="w-full h-full rounded-lg overflow-hidden">
                <iframe 
                  src={embedUrl} 
                  title={title} 
                  className="w-full h-full" 
                  frameBorder="0" 
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                  allowFullScreen 
                />
              </div>
            ) : (
              <div className="w-full h-full rounded-lg border border-white/20 flex items-center justify-center">
                <div className="text-center">
                  <Play className="w-16 h-16 text-gray-400 mx-auto mb-4" />
                  <p className="text-gray-400 text-lg">Invalid video URL</p>
                  <p className="text-gray-500 text-sm mt-2">Please check the video URL in admin settings</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DemoModal;